import i18n from 'client/i18n'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { createCoupon } from 'src/shared/entities/coupon/create-coupon'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'
import { ContainerBaseEntityUnionInterface } from 'src/shared/schemas/container-base-entity.schema'

export const createCouponFromLibrary = (
  container: OldEntityWithChildIds | ContainerBaseEntityUnionInterface,
  locale: string,
  position = 0,
) => {
  const fixedT = i18n.getFixedT(locale)

  const coupon = createCoupon(
    container.id,
    fixedT('entities.coupon.default_field_placeholder'),
    fixedT('entities.coupon.default_button_text'),
    container.masterBlockId,
  )

  return {
    [container.id]: {
      ...container,
      childIds: insertChild(container.childIds, coupon.id, position),
    },
    [coupon.id]: coupon,
  }
}
